import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updatePlaceInfo = async (placeId, update) => {
  if (!placeId || !update) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/info`,
    data: update,
  });
};